// @flow
import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc} from 'docs/markdoc/attribute-types';

export const ComplexityCallout: MarkdocTagRegistration = {
  tag: 'complexity-callout',
  component: 'ComplexityCallout',
  attributes: {
    complexity: {type: Number},
    color: {type: String, required: false},
    demo: {
      type: String,
      description: 'Used to display a custom demo in the UI',
      matches: ['elements', 'checkout'],
      required: false,
    },
    image: {type: ImageSrc, required: false},
    isHorizontal: {
      type: Boolean,
      default: true,
      required: false,
      description:
        'Defines how the card arranges content. A value of false is meant for large demos.',
    },
  },
};
